import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = ["content"]
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:card",
  property: "twitter:card",
  content: "summary_large_image"
}, null, -1)
const _hoisted_6 = ["content"]
const _hoisted_7 = ["content"]
const _hoisted_8 = ["content"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:site",
  property: "twitter:site",
  content: "@nslookupio"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:creator",
  property: "twitter:creator",
  content: "@ruurtjan"
}, null, -1)
const _hoisted_11 = ["content"]
const _hoisted_12 = ["content"]
const _hoisted_13 = ["content"]
const _hoisted_14 = ["content"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("meta", {
  name: "og:site_name",
  property: "og:site_name",
  content: "NsLookup.io"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("meta", {
  name: "og:type",
  property: "og:type",
  content: "article"
}, null, -1)
const _hoisted_17 = ["content"]
const _hoisted_18 = ["content"]
const _hoisted_19 = {
  key: 1,
  name: "og:type",
  property: "og:type",
  content: "website"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MetaTags',
  props: {
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: true,
  },
  img1024x512: {
    type: String,
    default: 'https://www.nslookup.io/img/social-1024x512.png',
  },
  img1200x630: {
    type: String,
    default: 'https://www.nslookup.io/img/social-1200x630.png',
  },
  written: Date,
  modified: Date,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("title", null, _toDisplayString(__props.title), 1),
    _createElementVNode("meta", {
      name: "description",
      content: __props.description
    }, null, 8, _hoisted_1),
    _createElementVNode("meta", {
      itemprop: "name",
      content: __props.title
    }, null, 8, _hoisted_2),
    _createElementVNode("meta", {
      itemprop: "description",
      content: __props.description
    }, null, 8, _hoisted_3),
    _createElementVNode("link", {
      rel: "canonical",
      href: __props.url
    }, null, 8, _hoisted_4),
    _hoisted_5,
    _createElementVNode("meta", {
      name: "twitter:title",
      property: "twitter:title",
      content: __props.title
    }, null, 8, _hoisted_6),
    _createElementVNode("meta", {
      name: "twitter:description",
      property: "twitter:description",
      content: __props.description
    }, null, 8, _hoisted_7),
    _createElementVNode("meta", {
      name: "twitter:image:src",
      property: "twitter:image:src",
      content: __props.img1024x512
    }, null, 8, _hoisted_8),
    _hoisted_9,
    _hoisted_10,
    _createElementVNode("meta", {
      name: "og:title",
      property: "og:title",
      content: __props.title
    }, null, 8, _hoisted_11),
    _createElementVNode("meta", {
      name: "og:description",
      property: "og:description",
      content: __props.description
    }, null, 8, _hoisted_12),
    _createElementVNode("meta", {
      name: "og:image",
      property: "og:image",
      content: __props.img1200x630
    }, null, 8, _hoisted_13),
    _createElementVNode("meta", {
      name: "og:url",
      property: "og:url",
      content: __props.url
    }, null, 8, _hoisted_14),
    _hoisted_15,
    (__props.written)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_16,
          _createElementVNode("meta", {
            name: "article:published_time",
            property: "article:published_time",
            content: __props.written.toISOString()
          }, null, 8, _hoisted_17),
          (__props.modified)
            ? (_openBlock(), _createElementBlock("meta", {
                key: 0,
                name: "article:modified_time",
                property: "article:modified_time",
                content: __props.modified.toISOString()
              }, null, 8, _hoisted_18))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("meta", _hoisted_19))
  ], 64))
}
}

})